/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EventCount = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        count: {
    type: 'number',
    isRequired: true,
},
    },
};